export const SET_APPLIED_FILTERS_COUNT = 'SET_APPLIED_FILTERS_COUNT';